import { clearNotify, notify, requestSubmit, sendRequest } from "../api";
import {
    ADD_IN_LIST,
    RESET_FORM,
    RESET_STATE,
    SET_DETAIL,
    SET_FORM,
    SET_QUICK_LIST,
    UPDATE_FORM
} from "../constant-types";
import { updateField, getField } from "vuex-map-fields";

const getDefaultState = () => {
    return {
        detail: null,
        form: { sale_items: [] },
        list_quick: []
    };
};

const getAvailableStock = (options, warehouseId) => {
    let idx = options.findIndex(o => o.warehouse_id === warehouseId)
    return idx >= 0 ? options[idx].base_qty_balance : 0
}

const getAvailableCashBalance = (options, userCashId) => {

}

export default {
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [ADD_IN_LIST](state, createdSaleReturn) {
            state.list_quick.unshift(createdSaleReturn);
        },
        ADD_OR_UPDATE_IN_LIST(state, saleReturn) {
            // find and update, when not found, then add by unshift
            let idx = state.list_quick.findIndex(lq => lq.id === saleReturn.id)
            if(idx >= 0) {
                state.list_quick[idx] = saleReturn
            } else {
                state.list_quick.unshift(saleReturn);
            }
        },
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState());
        },
        [SET_FORM](state) {
            // take some info from detail and build form
            state.form = {
                id: state.detail.id,
                payment_total : state.detail.payment_total,
                payment_done : state.detail.payment_done,
                payment_return: state.detail.payment_return,
                payment_remain: state.detail.payment_remain,
                return_to_user_cash_id: state.detail.return_to_user_cash_id,
                ref_return_to_user_cash_balance_available: state.detail.ref_return_to_user_cash_balance_available, // init from detail
                ref_return_to_user_cash_balance_after: 0, // ilustrate when cash is not enough
                return_apply_by_id: state.detail.return_apply_by_id,
                has_return: state.detail.has_return,
                sale_items: []
            };
            // item if have
            state.detail.sale_items.forEach(dpi => {
                state.form.sale_items.push({
                    id: dpi.id,
                    sale_id: dpi.sale_id,
                    product_name: dpi.product.name,
                    unit_name: dpi.unit.name,

                    stock_delivery_total: dpi.stock_delivery_total,
                    stock_delivery_received: dpi.stock_delivery_received,

                    option_stock_warehouses: dpi.product.stock_warehouses, // ref to return_to_warehouse_id
                    ref_stock_to_warehouse_available : getAvailableStock(dpi.product.stock_warehouses, dpi.return_to_warehouse_id),
                    ref_stock_to_warehouse_after: 0, // use just for ref, after subtracted from qty return

                    stock_delivery_return: dpi.stock_delivery_return,
                    return_reason: dpi.return_reason,

                    return_to_warehouse_id: dpi.return_to_warehouse_id,

                    stock_delivery_remain: dpi.stock_delivery_remain,
                    ref_stock_after_return: dpi.stock_delivery_received - dpi.stock_delivery_return
                });
            });
        },
        [RESET_FORM](state) {
            state.form = { sale_items: [] };
        },
        [SET_DETAIL](state, createdSaleReturn) {
            state.detail = createdSaleReturn;
        },
        [SET_QUICK_LIST](state, payload) {
            state.list_quick = payload;
        },
        [UPDATE_FORM](state, { updateType }) {
            // -> update should divide to avoid revision issue
            // update return of payment
            if (updateType === 'payment') {
                state.form.ref_return_to_user_cash_balance_after = state.form.ref_return_to_user_cash_balance_available - state.form.payment_return
                state.form.payment_remain = state.form.payment_total - state.form.payment_done
            } 
            // update remain calculation on sale items
            else if (updateType === 'items') {
                state.form.sale_items.forEach(fpi => {
                    fpi.ref_stock_to_warehouse_after = fpi.ref_stock_to_warehouse_available - fpi.stock_delivery_return

                    fpi.ref_stock_to_warehouse_after = fpi.ref_stock_to_warehouse_available - fpi.stock_delivery_return
                    fpi.ref_stock_after_return = fpi.stock_delivery_received - fpi.stock_delivery_return
                })
            }
        },
        updateField
    },
    // can async
    actions: {
        loadDetail({ commit, rootGetters }, saleId) {
            return sendRequest(
                `sale-return/sale/${saleId}`,
                {},
                "get",
                saleReturn => {
                    // insert available user cash
                    saleReturn['ref_return_to_user_cash_balance_available'] = rootGetters['userCash/getUserCashBalance'](saleReturn.return_to_user_cash_id)
                    commit(SET_DETAIL, saleReturn)
                }
            );
        },
        loadQuickList({ commit }) {
            return sendRequest("sale-return/quick", {}, "get", quickList =>
                commit(SET_QUICK_LIST, quickList)
            );
        },
        requestCreateSaleReturn({ commit, state, dispatch }) {
            return requestSubmit(
                "sale-return",
                state.form,
                commit,
                "post",
                createdSaleReturn => {
                    commit('ADD_OR_UPDATE_IN_LIST', createdSaleReturn),
                        // refresh user cash
                        dispatch("userCash/loadList", null, {
                            root: true
                        });
                    // set to detail
                    commit(SET_DETAIL, createdSaleReturn);
                    // reset form
                    commit(RESET_FORM)
                }
            );
        }
    },
    // call variable with custom display
    getters: {
        formValidated: state => {
            // when remain stock not negative and selected stock warehouse house must have enough stock to return it back, also payment remain should not negative
            if (state.form) {
                if (state.form.ref_return_to_user_cash_balance_after < 0) return false

                return state.form.sale_items.every( pi => {
                    if (pi.ref_stock_after_return < 0) return false
                    if (pi.stock_delivery_return < 0) return false
                    if (pi.stock_delivery_remain < 0) return false
                    if (pi.ref_stock_from_warehouse_after < 0) return false
                    if (!pi.return_reason) return false

                    return true
                })
                //return state.form.sale_items.every( pi => {
                    //if (pi.stock_delivery_return > 0) {
                        //return pi.stock_delivery_remain >= 0 && pi.ref_stock_to_warehouse_after >= 0  && pi.return_reason
                    //} else if (pi.stock_delivery_return < 0) {
                        //return false
                    //} else {
                        //return true
                    //}
                //})
            } else {
                return false;
            }
        },
        maxReturnAllowed: state => (itemIndex) => {
            let stockDeliveryReceived = state.form.sale_items[itemIndex].stock_delivery_received
            return stockDeliveryReceived
        },
        getField
    }
};
